import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  consultationId: string;
  patientId: string;
  visibility: string;
}

export const useToggleConsultationRelease = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ consultationId, visibility }: MutationProps) => {
      return api.patch(`report/${consultationId}/${visibility}`);
    },

    onError: (res: any) => {
      console.error("[From Toggle Consultation Release]", res);

      handleErrors(res, "mutation");
    },
  });
};
